import { render, staticRenderFns } from "./UploadMicroLearningPopup.vue?vue&type=template&id=71ab155e&scoped=true"
import script from "./UploadMicroLearningPopup.vue?vue&type=script&lang=js"
export * from "./UploadMicroLearningPopup.vue?vue&type=script&lang=js"
import style0 from "./UploadMicroLearningPopup.vue?vue&type=style&index=0&id=71ab155e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ab155e",
  null
  
)

export default component.exports